import Tooltip from '@components/v2/ui/Tooltip/Tooltip';
import Typography from '@components/v2/ui/Typography/Typography';
import { Box, TypographyProps } from '@mui/material';
import classNames from 'classnames';
import { DetailedHTMLProps, HTMLAttributes, ReactElement, ReactNode, memo } from 'react';
import { makeStyles } from 'tss-react/mui';
import useWidth from '../../../../Hooks/useWidth';

interface TextCellProps extends DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement> {
  firstField?: string;
  firstFieldClassName?: TypographyProps['className'];
  secondField?: string;
  secondFieldElement?: ReactNode;
  secondFieldClassName?: TypographyProps['className'];
  TooltipContent?: ReactElement | string;
  renderTwoFieldsInMobile?: boolean;
}

const useStyles = makeStyles()(() => ({
  firstField: {
    lineHeight: '16px',
  },
}));

const TextCell = ({
  firstField,
  firstFieldClassName,
  secondField,
  secondFieldElement,
  secondFieldClassName,
  TooltipContent,
  style,
  className,
  renderTwoFieldsInMobile,
}: TextCellProps) => {
  const { classes } = useStyles();
  const { mobileWidth } = useWidth();

  const firstFieldNode = (
    <Typography
      noWrap
      id="text-cell-first-field"
      className={classNames(classes.firstField, firstFieldClassName)}
      title={!TooltipContent ? firstField : undefined}
    >
      {firstField || '-'}
    </Typography>
  );

  return (
    <div style={{ width: '100%', minWidth: 0, ...style }} className={className}>
      <Tooltip TooltipContent={TooltipContent} fullWidth>
        <div style={{ width: '100%', minWidth: 0 }}>
          {renderTwoFieldsInMobile && mobileWidth ? (
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 8,
              }}
            >
              {firstFieldNode}
              <div>{secondFieldElement}</div>
            </Box>
          ) : (
            <div>
              {firstFieldNode}
              {secondFieldElement}
            </div>
          )}

          {secondField && (
            <Typography
              noWrap
              component="p"
              id="text-cell-second-field"
              variant="micro1"
              className={secondFieldClassName}
              color="text.tertiary"
              title={!TooltipContent ? secondField : undefined}
            >
              {secondField}
            </Typography>
          )}
        </div>
      </Tooltip>
    </div>
  );
};

export default memo(TextCell);
